// Copyright 2017 Sorama B.V.

export class CreditsError extends Error {
    constructor(message?: string) {
        super(message);
        this.name = "CreditsError";
    }
}
